<template>
  <a-modal
    :title="modalTitle"
    :visible="visible"
    :confirmLoading="saving"
    :width="860"
    :footer="isView ? null : undefined"
    destroyOnClose
    wrapClassName="timing-task-form-modal"
    okText="保存"
    cancelText="取消"
    @ok="handleSave"
    @cancel="handleClose"
  >
    <a-spin :spinning="loading">
      <a-descriptions
        v-if="isView && detailMeta"
        class="view-meta"
        :column="2"
        size="small"
        bordered
      >
        <a-descriptions-item label="规则ID">{{ detailMeta.id || '-' }}</a-descriptions-item>
        <a-descriptions-item label="任务名称">{{ detailMeta.taskName || '-' }}</a-descriptions-item>
        <a-descriptions-item label="状态">
          <a-badge
            :status="Number(detailMeta.enabled) === 1 ? 'success' : 'default'"
            :text="getEnabledText(detailMeta.enabled)"
          />
        </a-descriptions-item>
        <a-descriptions-item label="更新时间">{{ formatTime(detailMeta.updateTime) }}</a-descriptions-item>
        <a-descriptions-item label="最近商品同步">{{ formatTime(detailMeta.lastProductSyncTime) }}</a-descriptions-item>
        <a-descriptions-item label="最近价格同步">{{ formatTime(detailMeta.lastPriceSyncTime) }}</a-descriptions-item>
      </a-descriptions>

      <SyncConfigForm
        ref="form"
        v-model="form"
        :disabled="isView"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 20 }"
      />
      <div v-if="isView" class="view-footer">
        <a-button @click="handleClose">关闭</a-button>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import SyncConfigForm from './SyncConfigForm.vue'
import {
  createSyncConfigForm,
  mapDetailToForm,
  buildSpecifiedList,
  buildSaveParams,
  getEnabledText
} from '../utils/syncConfigHelper'

export default {
  name: 'TimingTaskFormModal',
  components: {
    SyncConfigForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'edit' // edit | view
    },
    taskId: {
      type: [Number, String],
      default: undefined
    }
  },
  data () {
    return {
      loading: false,
      saving: false,
      form: createSyncConfigForm(),
      detailMeta: null
    }
  },
  computed: {
    isView () {
      return this.mode === 'view'
    },
    modalTitle () {
      return this.isView ? '任务详情' : '编辑定时任务'
    }
  },
  watch: {
    visible (val) {
      if (val) this.open()
    }
  },
  methods: {
    getEnabledText,
    formatTime (value) {
      if (!value) return '-'
      const time = moment(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : value
    },
    getHttp () {
      return this.getHttpServices().getSourceService()
    },
    open () {
      this.form = createSyncConfigForm()
      this.detailMeta = null
      if (this.taskId == null) {
        this.$message.error('任务配置ID缺失')
        this.handleClose()
        return
      }
      this.loading = true
      const userInfo = this.$store.getters.userInfo || {}
      this.getHttp()
        .get('/qianqing/syncConfig/detail', {
          merchantId: userInfo.merchantId,
          id: this.taskId
        })
        .then(res => {
          const detail = res || {}
          this.form = mapDetailToForm(detail)
          this.detailMeta = {
            id: detail.id,
            taskName: detail.taskName,
            enabled: detail.enabled,
            updateTime: detail.updateTime,
            lastProductSyncTime: detail.lastProductSyncTime,
            lastPriceSyncTime: detail.lastPriceSyncTime
          }
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取任务详情失败，请重试')
          this.handleClose()
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSave () {
      if (this.isView) return
      const valid = await this.$refs.form.validate()
      if (!valid) return
      const userInfo = this.$store.getters.userInfo || {}
      if (this.form.syncType === 2 && !buildSpecifiedList(this.form, userInfo).length) {
        this.$message.warning('请填写有效的千擎线路编码')
        return
      }
      this.saving = true
      this.getHttp()
        .post('/qianqing/syncConfig/save', buildSaveParams(this.form, userInfo))
        .then(() => {
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleClose()
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '保存失败，请重试')
        })
        .finally(() => {
          this.saving = false
        })
    },
    handleClose () {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="less">
.view-meta {
  margin-bottom: 20px;

  /deep/ .ant-descriptions-item-label {
    width: 140px;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.45);
    background: #fafafa;
  }

  /deep/ .ant-descriptions-item-content {
    color: rgba(0, 0, 0, 0.85);
  }
}

.view-footer {
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  text-align: right;
}
</style>

<style lang="less">
.timing-task-form-modal {
  .ant-modal-body {
    max-height: 70vh;
    overflow-y: auto;
    padding-top: 16px;
  }

  .sync-config-form.is-readonly {
    .section-block {
      margin-bottom: 20px;
    }

    .section-title {
      font-size: 15px;
      margin-bottom: 12px;
    }

    .ant-input-number-disabled,
    .ant-input[disabled],
    .ant-radio-disabled + span {
      color: rgba(0, 0, 0, 0.65);
    }

    .ant-input-number-disabled {
      background: #fff;
      border-color: #e8e8e8;
      opacity: 1;
    }
  }
}
</style>
